import React, { useRef } from 'react';
import useEditorStore from '../../store/editorStore';
import GridOverlay from './GridOverlay';
import Block from '../blocks/Block';
import Section from '../sections/Section';
import './Canvas.css';

function Canvas() {
  const canvasRef = useRef(null);
  const { canvas, blocks, sections, zoom, deselectBlock, deselectSection, addBlock } = useEditorStore();

  const handleCanvasClick = (e) => {
    // Deselect block/section if clicking on empty canvas
    if (e.target === canvasRef.current || e.target.closest('.grid-overlay')) {
      deselectBlock();
      deselectSection();
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'copy';
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const blockType = e.dataTransfer.getData('blockType');
    if (!blockType) return;

    // Calculate drop position relative to canvas
    const rect = canvasRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left) / zoom;
    const y = (e.clientY - rect.top) / zoom;

    // Center the block on the cursor (approximate width/height)
    // Default sizes: Text/Image/QR ~ 150x150 or similar
    const offsetX = blockType === 'image' ? 100 : 75;
    const offsetY = blockType === 'text' ? 30 : 75;

    addBlock(blockType, { x: x - offsetX, y: y - offsetY });
  };

  return (
    <div className="canvas-wrapper" onClick={handleCanvasClick}>
      <div
        ref={canvasRef}
        className="canvas"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        style={{
          width: canvas.width,
          height: canvas.height,
          background: canvas.backgroundImage 
            ? `url(${canvas.backgroundImage}) center/cover no-repeat`
            : canvas.backgroundGradient
              ? canvas.backgroundGradient
              : canvas.backgroundColor,
          transform: `scale(${zoom})`,
          transformOrigin: 'center',
        }}
      >
        <GridOverlay />
        
        {/* Render sections first (as containers) */}
        {sections
          .sort((a, b) => a.zIndex - b.zIndex)
          .map((section) => (
            <Section key={section.id} section={section} />
          ))}
        
        {/* Render blocks on top */}
        {blocks
          .sort((a, b) => a.zIndex - b.zIndex)
          .map((block) => (
            <Block key={block.id} block={block} />
          ))}
      </div>
    </div>
  );
}

export default Canvas;
